import { db } from "../firebase/config";
import {
  collection,
  addDoc,
  getDocs,
  query,
  where,
  doc,
  updateDoc,
  deleteDoc,
  Timestamp,
} from "firebase/firestore";

export const createOrder = async (orderData) => {
  try {
    const ordersRef = collection(db, "orders");
    const orderWithTimestamp = {
      ...orderData,
      createdAt: Timestamp.fromDate(new Date(orderData.createdAt)),
      updatedAt: Timestamp.fromDate(new Date(orderData.updatedAt)),
      jobNumber: orderData.jobNumber || "", // Ensure jobNumber is included
      contactName: orderData.contactName || "", // Ensure contactName is included
    };
    const docRef = await addDoc(ordersRef, orderWithTimestamp);
    return { id: docRef.id, ...orderWithTimestamp };
  } catch (error) {
    console.error("Error creating order:", error.message, error.stack);
    throw new Error(`Failed to create order: ${error.message}`);
  }
};

export const updateOrder = async (orderId, orderData) => {
  try {
    if (!orderId) {
      throw new Error("Order ID is missing");
    }
    const orderRef = doc(db, "orders", orderId);
    const orderWithTimestamp = {
      ...orderData,
      createdAt:
        orderData.createdAt instanceof Timestamp
          ? orderData.createdAt
          : Timestamp.fromDate(new Date(orderData.createdAt)),
      updatedAt: Timestamp.fromDate(new Date(orderData.updatedAt)),
      jobNumber: orderData.jobNumber || "", // Ensure jobNumber is included
      contactName: orderData.contactName || "", // Ensure contactName is included
    };
    await updateDoc(orderRef, orderWithTimestamp);
    return { id: orderId, ...orderWithTimestamp };
  } catch (error) {
    console.error("Error updating order:", error.message, error.stack);
    throw new Error(`Failed to update order: ${error.message}`);
  }
};

export const getOrders = async (userId) => {
  try {
    if (!userId) {
      throw new Error("User ID is missing");
    }
    const ordersRef = collection(db, "orders");
    const q = query(ordersRef, where("userId", "==", userId));
    const querySnapshot = await getDocs(q);
    const orders = [];
    querySnapshot.forEach((doc) => {
      orders.push({ id: doc.id, ...doc.data() });
    });
    return orders;
  } catch (error) {
    console.error("Error fetching orders:", error.message, error.stack);
    throw new Error(`Failed to fetch orders: ${error.message}`);
  }
};

export const deleteOrder = async (orderId) => {
  try {
    if (!orderId) {
      throw new Error("Order ID is missing");
    }
    const orderRef = doc(db, "orders", orderId);
    await deleteDoc(orderRef);
  } catch (error) {
    console.error("Error deleting order:", error.message, error.stack);
    throw new Error(`Failed to delete order: ${error.message}`);
  }
};
